import { useState, useEffect, useCallback } from 'react';
import { getBudget, saveBudget, computeCategoryStatus } from '@/services/budgetService';
import { getCategoryTotals } from '@/services/expenseService';
import { useAppContext } from '@/context/AppContext';

export function useBudget(month) {
  const [budget, setBudget]           = useState(null);
  const [categoryTotals, setCatTotals] = useState({});
  const [categoryStatus, setCatStatus] = useState({});
  const [loading, setLoading]          = useState(true);
  const { showToast }                  = useAppContext();

  const load = useCallback(async () => {
    if (!month) return;
    setLoading(true);
    try {
      const [b, totals] = await Promise.all([
        getBudget(month),
        getCategoryTotals(month),
      ]);
      setBudget(b);
      setCatTotals(totals);
      setCatStatus(computeCategoryStatus(b, totals));
    } catch (err) {
      console.error('useBudget load error:', err);
    } finally {
      setLoading(false);
    }
  }, [month]);

  useEffect(() => { load(); }, [load]);

  const save = useCallback(async ({ totalBudget, categories }) => {
    await saveBudget(month, { totalBudget, categories });
    await load();
    showToast('Budget saved ✓', 'success');
  }, [month, load, showToast]);

  const totalSpent = Object.values(categoryTotals).reduce((s, v) => s + v, 0);
  const remaining  = (budget?.totalBudget ?? 0) - totalSpent;

  return {
    budget,
    categoryTotals,
    categoryStatus,
    totalSpent,
    remaining,
    loading,
    save,
    refetch: load,
  };
}
